import { Component, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import {
   PhoneNumberDetailDeleteEvent,
   PhoneNumberDetailReleaseEvent,
} from 'src/app/pages/phone-number-details/models/phone-number-detail-form-submit-event';
import * as PhoneNumberDetailActions from 'src/app/pages/phone-number-details/state/phone-number-detail.actions';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { PhoneNumbersFilterOption } from '../../models/phone-number-filter-option';
import { PhoneNumberRegister } from '../../phone-number-register';
import { Observable } from 'rxjs';
import { getCurrentUserIsSystemUser } from 'src/app/authentication/state/authentication.selector';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-phone-number-register',
    templateUrl: './account-phone-number-register.component.html',
    standalone: false
})
export class AccountPhoneNumberRegisterComponent extends PhoneNumberRegister {
   isSystemUser$: Observable<boolean>;
   constructor(public store: Store) {
      super(store);
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: PhoneNumbersFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = [
         'phoneNumber',
         'location',
         'faxExtensionId',
         'openExtension',
         'closedExtension',
         'schedule',
         'isActive',
         'isE911Registered',
         'accountPhoneNumberActionsMenu',
      ];
   }
   onNumberReleased(event: PhoneNumberDetailReleaseEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.releasePhoneNumberDetail(event));
   }

   onNumberDeleted(event: PhoneNumberDetailDeleteEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.deletePhoneNumberDetailFromNDT(event));
   }
}
